import Script from 'next/script';

const Flourish = (props) => {
    const { text } = props;
    const flourishEmbeds = text?.match(/<div class="flourish-embed[\s\S]*?<\/div>/g);

    return flourishEmbeds ? (
        <>
            <Script src='https://public.flourish.studio/resources/embed.js' strategy='afterInteractive' />

            {flourishEmbeds.map((embed, i) => {
                const cleanedEmbed = embed.replace(/<script[\s\S]*?<\/script>/, '');
                return (
                    <div
                        key={`flourish-embed-${i}`}
                        className='raw-html-embed'
                        dangerouslySetInnerHTML={{ __html: cleanedEmbed }}
                    />
                );
            })}
        </>
    ) : (
        <></>
    );
};

export default Flourish;
